import { render, staticRenderFns } from "./BusEkpEntryorbothConfigList.vue?vue&type=template&id=e38fe0c4&scoped=true&"
import script from "./BusEkpEntryorbothConfigList.vue?vue&type=script&lang=js&"
export * from "./BusEkpEntryorbothConfigList.vue?vue&type=script&lang=js&"
import style0 from "./BusEkpEntryorbothConfigList.vue?vue&type=style&index=0&id=e38fe0c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e38fe0c4",
  null
  
)

export default component.exports